import React from 'react';
import { Tooltip } from 'reactstrap';

const Square = (props) => {
  const [tooltipOpen, setTooltipOpen] = React.useState(false);
  const toggle = () => setTooltipOpen(!tooltipOpen);
  return (
    <>
      <Tooltip
        placement="auto"
        isOpen={tooltipOpen}
        target={props.id}
        toggle={toggle}
      >
        {props.groupName}
      </Tooltip>
      <div
        id={props.id}
        className="d-flex"
        style={{
          width: props.w,
          height: props.h,
          top: props.y,
          left: props.x,
          backgroundColor: props.fill,
          position: 'absolute',
          border: '1px solid black',
          zIndex: (props.index || 0) + 1,
        }}
      ></div>
    </>
  );
};

Square.defaultProps = {
  w: 1,
  h: 1,
  x: 0,
  y: 0,
  fill: '#007bff',
};
export default Square;
